module.exports = __webpack_public_path__ + "blissweb-lt.2128de822b4c06d3225c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Lt/blissweb-lt.eot
// module id = 154
// module chunks = 5